import { render, staticRenderFns } from "./record.pug?vue&type=template&id=e937fb64&lang=pug&"
import script from "./record.ts?vue&type=script&lang=ts&"
export * from "./record.ts?vue&type=script&lang=ts&"
import style0 from "./record.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports